module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap"
  }, [_vm._v(" Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Johnny Temple is one of the finest publishers in America today. In this digital age when there are dismal predictions about the future of the printed word, he and his senior editor Ibrahim Ahmad are beacons of hope with their commitment to good literature and their courage not to be daunted by the naysayers. I am eternally grateful to them for their razor-sharp guidance with this book and two of my novels.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I had not thought of writing a memoir until I was persuaded to do so by the editors of the fine collection of essays "), _c('i', [_vm._v("Shakespeare’s Sisters")]), _vm._v(", and by my dear friend and poet Linda Susan Jackson. I thank them for opening up a world to me that I may have forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("As always, my thanks to my son, Jason Harrell, for his love and support, and to his wife, Denise, and my sister Mary Nunez, who continually give me encouragement.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c560b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 69
// module chunks = 0